import React from 'react';
import { Navigate, NavLink, Route, Routes } from 'react-router-dom';
import WhatsAppSidebar from '../../components/WhatsApp/WhatsAppSidebar';
import WhatsAppInboxPanel from '../../components/WhatsApp/WhatsAppInboxPanel';
import WhatsAppAnalyticsPanel from '../../components/WhatsApp/WhatsAppAnalyticsPanel';
import WhatsAppDeliveryPanel from '../../components/WhatsApp/WhatsAppDeliveryPanel';
import WhatsAppSettingsPanel from '../../components/WhatsApp/WhatsAppSettingsPanel';
import WhatsAppTemplatesPanel from '../../components/WhatsApp/WhatsAppTemplatesPanel';
import WhatsAppContactsPanel from '../../components/WhatsApp/WhatsAppContactsPanel';
import WhatsAppSendTemplatePanel from '../../components/WhatsApp/WhatsAppSendTemplatePanel';
import WhatsAppCampaignsPanel from '../../components/WhatsApp/WhatsAppCampaignsPanel';
import WhatsAppCampaignDetailPage from '../../components/WhatsApp/WhatsAppCampaignDetailPage';
import WhatsAppCampaignEditorPage from '../../components/WhatsApp/WhatsAppCampaignEditorPage';
import WhatsAppNotificationsPanel from '../../components/WhatsApp/WhatsAppNotificationsPanel';
import WhatsAppRetargetingPanel from '../../components/WhatsApp/WhatsAppRetargetingPanel';
import WhatsAppTestingPanel from '../../components/WhatsApp/WhatsAppTestingPanel';
import { waMobileTabs, waPageWrap, waShell } from '../../components/WhatsApp/whatsappUi';
import { WHATSAPP_TABS, WHATSAPP_BASE_PATH } from '../../models/MasterAdmin/whatsappHub';

const MOBILE_TAB_IDS = ['inbox', 'send', 'contacts', 'campaigns', 'templates', 'notifications', 'retargeting', 'delivery', 'analytics', 'settings', 'testing'] as const;

/** Scrollable mobile tab bar */
const WhatsAppMobileTabs: React.FC = () => (
  <div className={`${waMobileTabs} md:hidden`}>
    {WHATSAPP_TABS.filter((t) => MOBILE_TAB_IDS.includes(t.id as (typeof MOBILE_TAB_IDS)[number])).map((tab) => (
      <NavLink
        key={tab.path}
        to={tab.path}
        end={tab.id === 'inbox'}
        className={({ isActive }) =>
          `shrink-0 px-3 py-2.5 text-center text-xs font-medium whitespace-nowrap ${
            isActive
              ? 'border-b-2 border-[#25D366] text-[#25D366]'
              : 'text-gray-600 dark:text-gray-300'
          }`
        }
      >
        {tab.label}
      </NavLink>
    ))}
  </div>
);

const WhatsAppHubPage: React.FC = () => {
  return (
    <div className={waPageWrap}>
      <WhatsAppMobileTabs />
      <div className={waShell}>
        <WhatsAppSidebar />
        <main className="flex min-w-0 flex-1 flex-col overflow-hidden">
          <Routes>
            <Route index element={<WhatsAppInboxPanel />} />
            <Route path="send" element={<WhatsAppSendTemplatePanel />} />
            <Route path="testing" element={<WhatsAppTestingPanel />} />
            <Route path="contacts" element={<WhatsAppContactsPanel />} />
            <Route path="campaigns/new" element={<WhatsAppCampaignEditorPage />} />
            <Route path="campaigns/:campaignId/edit" element={<WhatsAppCampaignEditorPage />} />
            <Route path="campaigns/:campaignId" element={<WhatsAppCampaignDetailPage />} />
            <Route path="campaigns" element={<WhatsAppCampaignsPanel />} />
            <Route path="templates" element={<WhatsAppTemplatesPanel />} />
            <Route path="notifications" element={<WhatsAppNotificationsPanel />} />
            <Route path="retargeting" element={<WhatsAppRetargetingPanel />} />
            <Route path="delivery" element={<WhatsAppDeliveryPanel />} />
            <Route path="analytics" element={<WhatsAppAnalyticsPanel />} />
            <Route path="settings" element={<WhatsAppSettingsPanel />} />
            <Route path="*" element={<Navigate to={WHATSAPP_BASE_PATH} replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default WhatsAppHubPage;
